import { render, staticRenderFns } from "./AppScreenshotCard.vue?vue&type=template&id=49d4ac12&scoped=true&"
import script from "./AppScreenshotCard.vue?vue&type=script&lang=js&"
export * from "./AppScreenshotCard.vue?vue&type=script&lang=js&"
import style0 from "./AppScreenshotCard.vue?vue&type=style&index=0&id=49d4ac12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4ac12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular})
